export default class LinkService {
    THEORY_PIANO_MAJ_MIN  = '/theory/piano/major_minor_scales'
    THEORY_PIANO_TRIADS   = '/theory/piano/triad_chords'
    PIANO_TRIAD_REFERENCE     =  '/theory/piano/root_triad_chord_reference'
    THEORY_TRI_MIN = '/theory/guitar/triads/minor'
    THEORY_TRI_MAJ = '/theory/guitar/triads/major'
    THEORY_TRI_MAJ_MIN_DIM = '/theory/guitar/triads/major_minor_diminished'
    THEORY_TRI_SUS2 = '/theory/guitar/triads/sus2'
    THEORY_TRI_SUS4 = '/theory/guitar/triads/sus4'
    THEORY_TRI_DIM = '/theory/guitar/triads/diminished'
    EX_NOTE_ID = '/exercises/guitar/note_identification'
    EX_TRIAD_MAJ = '/exercises/guitar/major_triads'
    EX_TRIAD_MIN = '/exercises/guitar/minor_triads'
    EX_TRIAD_DIM = '/exercises/guitar/diminished_triads'
    EX_TRIAD_MAJ_MIN_DIM = '/exercises/guitar/maj_min_dim_triads'
    EX_TRIAD_SUS2 = '/exercises/guitar/sus2_triads'
    EX_TRIAD_SUS4 = '/exercises/guitar/sus4_triads'
    constructor() {
    }

}
